export default __webpack_public_path__ + "static/media/project_moosejs.71418b33.png";